module.exports = __webpack_public_path__ + "img/dsci0068.a28e2501.jpg";